import Login from "./Login/login";

const authConfig = {
  settings: {},
  routes: [
    {
      path: "/login11",
      component: Login,
      exact: true,
    },
  ],
};

export default authConfig;
